import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IgeneralResponse03 } from '../app/Interfaces/igeneralresponse02';
import { IGRDataProduction, IPutDataProduction } from '../app/Interfaces/ipas';
import { AddPasOptionGroup, IGRPASOptions, IPASOption, IRPASOptionsGroup, IRPASOptionsGroupSelect, IRPO, IRPOG, IRPOGData, POGSelect, UpdatePasOptionGroup, UpdatePO } from '../app/Interfaces/iproduction';
import { environment } from '../environments/environment';
import { DataService } from './data.service';
import {IComponents, IGroupComponent, IGetGroupComponentData, IGroupComponentSingle, IFixedComponentAdd } from '../app/Interfaces/Integrations/IProduction';

@Injectable()
export class PASPrdService {
  private storage: any;
  private baseUrl = environment.urlAPI;

  constructor(private http: HttpClient, private dataService: DataService) { }

  //Get group complex compositions belonging a PAS
  public GetComplexCompositionGroups(PASId: number) {
    let url = environment.urlAPI + 'api/pascomposition/v1/groupcomplexcomponents/';
    try {
      return this.dataService.get<IGroupComponent>(url + PASId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  } 

  //Add fixed component
  public AddFixedComponent(data: IFixedComponentAdd) {
  let url = environment.urlAPI + 'api/pascomposition/v1/fixedcomponent/';
  try {
    return this.dataService.post<IgeneralResponse03>(url, data).
      pipe(res => { return res });
  }
  catch (e) {
    console.log(e);
  }
}

  //Get fixed composition data
  public GetFixedComponents(pasId: number) {
    let url = environment.urlAPI + 'api/pascomposition/v1/fixedcomponents/data/';
    try {
      return this.dataService.get<IComponents>(url +pasId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Get group compositions belonging a PAS
  public GetCompositionGroupsBelongingPAS(PASId: number) {
    let url = environment.urlAPI + 'api/pascomposition/v1/groupcomponentsbelongingpas/';
    try {
      return this.dataService.get<IGroupComponent>(url + PASId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  } 

  //Get Composition components belonging a Group
  public GetComponents(GroupComponentId:number) {
    let url = environment.urlAPI + 'api/pascomposition/v1/components/';
    try {
      return this.dataService.get<IComponents>(url+GroupComponentId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Get Composition group using Id
  public GetGroupComponent(Id: number) {
    let url = environment.urlAPI + 'api/pascomposition/v1/groupcomponent/';
    try {
      return this.dataService.get<IGroupComponentSingle>(url + Id).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Get Composition groups using filters
  public GetCompositionGroups(Data: IGetGroupComponentData) {
    let url = environment.urlAPI + 'api/pascomposition/v1/compositiongroups/';
    try {
      return this.dataService.post<IGroupComponent>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //PAS Option groups unselect 
  public POGUnSelect(Data:POGSelect) {
    let url = environment.urlAPI + 'api/pasprd/v1/pogunselect/';
    try {
      return this.dataService.put<IgeneralResponse03>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //PAS Option groups select
  public POGSelect(Data:POGSelect) {
    let url = environment.urlAPI + 'api/pasprd/v1/pogselect/';
    try {
      return this.dataService.post<IgeneralResponse03>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Update PAS Option 
  public UpdatePO(Data: UpdatePO) {
    let url = environment.urlAPI + 'api/pasprd/v2/po/';
    try {
      return this.dataService.put<IgeneralResponse03>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Get PAS Option group
  public GetPO(Id: number) {
    let url = environment.urlAPI + 'api/pasprd/v1/po/';
    try {
      return this.dataService.get<IRPO>(url + Id).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Get PAS Option group
  public GetPOG(Id: number) {
  let url = environment.urlAPI + 'api/pasprd/v1/pog/';
  try {
    return this.dataService.get<IRPOGData>(url + Id).
      pipe(res => { return res });
  }
  catch (e) {
    console.log(e);
  }
}

  //Edit PAS Option groups
  public UpdatePOG(Data: UpdatePasOptionGroup) {
    let url = environment.urlAPI + 'api/pasprd/v2/pog/';
    try {
      return this.dataService.put<IgeneralResponse03>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Put PAS Option 
  public AddPO(Data: IPASOption) {
    let url = environment.urlAPI + 'api/pasprd/v2/pasoption/';
    try {
      return this.dataService.post<IgeneralResponse03>(url, Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Put PAS Option Group
  public AddPOG(Data: AddPasOptionGroup) {
    let url = environment.urlAPI + 'api/pasprd/v1/pasoptionsgroup/';
    try {
      return this.dataService.post<IRPOG>(url,Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  public GetPASOptionsGroupSelect(PASId: number) {
    try {
      let url = this.baseUrl + 'api/pasprd/v1/optionsgroupselect/';
      return this.dataService.get<IRPASOptionsGroupSelect>(url +PASId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public GetPASOptionsGroup(PTextOption: string, Status:number ) {
    try {
      let url = this.baseUrl + 'api/pasprd/v1/pasoptionsgroup/';
      if (PTextOption.length == 0) PTextOption = "*";
      return this.dataService.get <IRPASOptionsGroup>(url + PTextOption.trim()+"/"+Status).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public GetGroupOptions(GroupId: number) {
    try {
      let url = this.baseUrl + 'api/pasprd/v1/pasoptions/';
      return this.dataService.get<IGRPASOptions>(url +GroupId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  //Delete data production in CC
  public DeleteDataProduction(PId: number) {
    let url = environment.urlAPI + 'api/pasprd/v1/dataproduction/';
    try {
      return this.dataService.delete<IgeneralResponse03>(url + PId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //get production data 
  public DataProduction(PCCId: number, PPASId: number) {
    let url = environment.urlAPI + 'api/pasprd/v1/dataproduction/';
    try {
      return this.dataService.get<IGRDataProduction>(url + PCCId + "/" + PPASId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //Put data production in CC
  public PutDataProduction(PDataProduction: IPutDataProduction) {
    let url = environment.urlAPI + 'api/pasprd/v1/dataproduction/';
    try {
      return this.dataService.put<IgeneralResponse03>(url, PDataProduction).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

  //add data production in CC
  public AddDataProduction(PDataProduction: IPutDataProduction) {
    let url = environment.urlAPI + 'api/pasprd/v1/dataproduction/';
    try {
      return this.dataService.post<IgeneralResponse03>(url, PDataProduction).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e);
    }
  }

}
